<template>
    <div class="w100">
        <el-radio-group v-model="type" class="q-add-type" @change="changeType">
            <el-radio-button label="发布报价"></el-radio-button>
            <el-radio-button label="发布商情"></el-radio-button>
        </el-radio-group>
        <!-- 发布报价 start -->
        <div v-show="type == '发布报价' && hasOfferRoot && !quoteNone">

            <el-row style="margin-top: 20px;">
                <el-col :span="12">
                    <span class="table-title font16 fontNormal">{{ title }}</span>
                </el-col>
                <el-col :span="12">
                    <div class="quote-add-btns textRight">
                        <el-button size="small" type="danger" @click="showBatch">批量改价</el-button>
                        <el-button size="small" type="danger" @click="showVarieties">按品种改价</el-button>
                    </div>
                </el-col>
            </el-row>

            <el-table :data="quoteList" class="w100 mw-modular-box" border @selection-change="selectionChange">
                <el-table-column type="selection" width="" align="center" header-align="center" fixed></el-table-column>
                <el-table-column prop="varietiesName" label="品种" width="120" align="center" header-align="center" fixed></el-table-column>
                <el-table-column prop="attribute" label="属性" width="120" align="center" header-align="center"></el-table-column>
                <el-table-column label="价格(元/吨)" width="160" prop="price" sortable align="center" header-align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.price }}</span> <!--v-show="!scope.row.isShowPriceInput" @dblclick="showPriceInput(scope.row)"-->
                        <el-input placeholder="请输入内容" type="number" v-model="scope.row.price" size="mini" v-show="scope.row.isShowPriceInput" @blur="hidePriceInput(scope.row, scope.$index)"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="备注" width="120" align="center" header-align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.remark }}</span><!-- v-show="!scope.row.isShowRemarkInput" @dblclick="showRemarkInput(scope.row)"-->
                        <el-input placeholder="请输入内容" v-model="scope.row.remark" clearable size="mini" v-show="scope.row.isShowRemarkInput" @blur="hideRemarkInput(scope.row, scope.$index)"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="market" label="市场" width="120" align="center" header-align="center"></el-table-column>
                <el-table-column prop="factory" label="产地/厂家" width="120" align="center" header-align="center"></el-table-column>
                <el-table-column prop="warehouse" label="仓库" width="120" align="center" header-align="center"></el-table-column>
                <el-table-column prop="createTime" label="发布时间" width="120" sortable align="center" header-align="center"></el-table-column>
                <el-table-column label="操作" width="160" align="center" header-align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleDetail(scope.$index, scope.row)">详情</el-button>
                        <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)" :disabled="isSubmitLoading">发布</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- <div style="padding-bottom: 20px">
                <el-button size="mini" type="primary" @click="addQuote()">发布报价</el-button>
            </div> -->

            <!-- 分页 start -->
            <!-- <div class="textCenter" style="padding-top: 20px; padding-bottom: 20px;" v-show="true">
                <el-pagination background @current-change="handleCurrentChange" :current-page="pageNo" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalnum"></el-pagination>
            </div> -->
            <!-- 分页 end -->
        </div>
        <div class="textCenter font16 fontNormal" style="margin-top: 60px;" v-show="type == '发布报价' && quoteNone">
            暂无数据~
        </div>
        <div class="textCenter font16 fontNormal" style="margin-top: 60px;" v-show="type == '发布报价' && !hasOfferRoot">
            想要发布报价，请联系您的专属客服~
        </div>
        <!-- 发布报价 end -->

        <!-- 发布商情 start -->
        <el-form ref="formTrade" :model="formTrade" label-width="140px" v-show="type == '发布商情' && hasBusinessRoot" class="form-trade center">
            <el-form-item label="主营产品">
                <div style="width: 500px;">
                    <el-tag v-for="(item, index) in enterpriseInfo.varieties" :key="index" class="trade-tag">{{ item.name }}</el-tag>
                </div>
            </el-form-item>
            <el-form-item label="发布内容：">
                <el-input v-model="formTrade.content" type="textarea" style="width: 500px;" placeholder="请输入"
                maxlength="220"
                show-word-limit
                rows="10">
                </el-input>
            </el-form-item>
            <el-form-item class="trade-add-btns textCenter">
                <el-button  type="danger" @click="onTradeSubmit" :disabled="isSubmitLoading">发布商情</el-button>
            </el-form-item>
        </el-form>
        <div class="textCenter font16 fontNormal" style="margin-top: 60px;" v-show="type == '发布商情' && !hasBusinessRoot">
            想要发布商情，请联系您的专属客服~
        </div>
        <!-- 发布商情 end -->

        <!-- 按品种改价 start -->
        <el-dialog title="按品种改价" :close-on-click-modal=false :close-on-press-escape=false :visible.sync="dialogWithVarieties" width="600px" style="padding: 10px 0;">
            <el-form ref="" label-width="120px">
                <el-form-item label="所选品种：">
                    <el-checkbox-group v-model="batchTypeCheck">
                        <el-checkbox v-for="(item, index) in batchType" :key="index" :label="item.name" name="type" @change="changeBatchType(item)"></el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="批量价格修改：" prop="price">
                    <el-input v-model="batchPrice" type="number" style="width: 240px;"></el-input>
                </el-form-item>
                <!--<div class="fontRed" style="margin: 15px 0;">输入正值为加价，输入负值为减价，所填价格均在原有价格基础上增减</div>-->
                <el-form-item>
                    <el-button size="small" @click="dialogWithVarieties = false">取消</el-button>
                    <el-button size="small" type="primary" @click="onBatchSubmit2" :disabled="isSubmitLoading">保存</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <!-- 按品种改价 end -->
        <!-- 批量改价 start -->
        <el-dialog title="批量改价" :close-on-click-modal=false :close-on-press-escape=false :visible.sync="dialogWithBatch" width="600px" style="padding: 10px 0;">
            <el-form ref="" label-width="120px">
                <p class="font16 fontNormal" style="margin-top: -20px; margin-bottom: 15px;">当前选中 <span class="fontRed fontBold">{{ checksNum }}</span> 项内容</p>
                <el-form-item label="批量价格修改：" prop="batchPrice">
                    <el-input v-model="batchPrice" type="number" style="width: 240px;"></el-input>
                </el-form-item>
               <!-- <div class="fontRed" style="margin: 15px 0;">输入正值为加价，输入负值为减价，所填价格均在原有价格基础上增减</div>-->
                <el-form-item>
                    <el-button size="small" @click="dialogWithBatch = false">取消</el-button>
                    <el-button size="small" type="primary" @click="onBatchSubmit" :disabled="isSubmitLoading">保存</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <!-- 批量改价 end -->

        <!-- 编辑 start -->
        <el-dialog title="发布" :close-on-click-modal=false :close-on-press-escape=false :visible.sync="dialogWithEdit" width="450px" style="padding: 10px 0;">
            <el-form ref="formEdit" :model="formEdit" label-width="120px" :rules="rulesEdit" size="small">
                <el-form-item label="品种：" prop="varietiesName">
                    <el-input v-model="formEdit.varietiesName" style="width: 240px;" :disabled="true"></el-input>
                </el-form-item>
                <!--<el-form-item label="属性：" prop="attribute">
                    <el-input v-model="formEdit.attribute" style="width: 240px;" :disabled="true"></el-input>
                </el-form-item>-->
                                <el-form-item :label="item.content+'：'" prop="item"  v-for="(item, index) in formEdit.attribute2" :key="index">
                    <el-input v-model="item.fieldValue" style="width: 240px;" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="价格(元/吨)：" prop="price">
                    <el-input v-model="formEdit.price" type="number" style="width: 240px;" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item :label="item.content" v-for="(item, index) in formEdit.attributeInfos" :key="index">
                    <el-input  v-for="(cItem, cIndex) in item.fieldInfos" :key="cIndex" v-model="cItem.fieldValue" style="width: 240px;" placeholder="请输入" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="市场：">
                    <el-input v-model="formEdit.market" style="width: 240px;" placeholder="请输入" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="仓库：">
                    <el-input v-model="formEdit.warehouse" style="width: 240px;" placeholder="请输入" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="产地/厂家：">
                    <el-input v-model="formEdit.factory" style="width: 240px;" placeholder="请输入" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="发布时间：">
                    <el-date-picker v-model="formEdit.offerDate" type="date" placeholder="选择日期" style="width: 240px;" :disabled="true"></el-date-picker>
                </el-form-item>
                <el-form-item label="备注：">
                    <el-input v-model="formEdit.remark" type="textarea" style="width: 240px;" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" @click="onVarietiesSubmit" :disabled="isSubmitLoading">保存</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <!-- 编辑 end -->
        <!-- 详情 start -->
        <el-dialog title="详情" :close-on-click-modal=false :close-on-press-escape=false :visible.sync="dialogWithDetail" width="450px" style="padding: 10px 0;">
            <el-form ref="dialogWithDetail" :model="formEdit" label-width="120px" size="small">
                <el-form-item label="品种：" prop="varietiesName">
                    <span class="fontNormal font16">{{ formEdit.varietiesName }}</span>
                </el-form-item>
                <!--<el-form-item label="属性：" prop="attribute">
                    <span class="fontNormal font16">{{ formEdit.attribute }}</span>
                </el-form-item>-->
                
                <el-form-item :label="item.content+'：'" prop="item"  v-for="(item, index) in formEdit.attribute2" :key="index">
                    <span class="fontNormal font16">{{ item.fieldValue}}</span>
                </el-form-item>
                
                <el-form-item label="价格(元/吨)：" prop="price">
                    <span class="fontNormal font16">{{ formEdit.price }}</span>
                </el-form-item>
                <el-form-item :label="item.content" v-for="(item, index) in formEdit.attributeInfos" :key="index">
                    <span class="fontNormal font16" v-for="(cItem, cIndex) in item.fieldInfos" :key="cIndex">{{ cItem.fieldValue }}</span>
                </el-form-item>
                <el-form-item label="市场：">
                    <span class="fontNormal font16">{{ formEdit.market }}</span>
                </el-form-item>
                <el-form-item label="仓库：">
                    <span class="fontNormal font16">{{ formEdit.warehouse }}</span>
                </el-form-item>
                <el-form-item label="产地/厂家：">
                    <span class="fontNormal font16">{{ formEdit.factory }}</span>
                </el-form-item>
                <el-form-item label="发布时间：">
                    <span class="fontNormal font16">{{ formEdit.offerDate }}</span>
                </el-form-item>
                <el-form-item label="备注：">
                    <span class="fontNormal font16">{{ formEdit.remark }}</span>
                </el-form-item>
            </el-form>
        </el-dialog>
        <!-- 详情 end -->
    </div>
</template>
<script>
import $ from 'jquery'
import { baseUrl, getQueryString } from '../assets/js/common'
export default {
    name: 'QuoteControl',
    components: {},
    data() {
        return {
            userInfo: {},
            enterpriseInfo: {},
            type: '发布报价',
            title: '企业报价信息',
            
            pageNo: 1,
            pageSize: 10,
            totalnum: 0,
            quoteList: [],
            quoteNone: false,
            

            // 批量改价
            dialogWithBatch: false,
            batchPrice: 0,
            checksNum: 8,
            // 按品种改价
            dialogWithVarieties: false,
            batchType: [],
            checkBatchType: [],
            batchTypeCheck: [], // 没用，但是绑定要用

            // 编辑
            dialogWithEdit: false,
            // formEdit: {
            //     id: '',
            //     enterpriseVarietiesId: '',
            //     price: '', // 价格
            //     createTime: '', // 发布时间
            //     varietiesName: '', // 品种名称
            //     attribute: '', // 属性
            //     market: '', // 市场
            //     factory: '', // 产地/厂家
            //     warehouse: '', // 仓库
            //     remark: '', // 备注
            //     attributeInfos: [],
            // },
            formEdit: {
                id: '',
                enterpriseVarietiesId: '',
                price: '', // 价格
                offerDate: '',
                varietiesName: '', // 品种名称
                attribute: '', // 属性
                                attribute2: [], // 属性
                market: '', // 市场
                factory: '', // 产地/厂家
                warehouse: '', // 仓库
                remark: '', // 备注
                attributeInfos: [],
                isShowPriceInput: false,
                isShowRemarkInput: false
            },
            rulesEdit: {
                varietiesName: [{ required: true }],
                price: [{ required: true, message: '请输入价格', trigger: 'blur' }]
            },

            // 详情
            dialogWithDetail: false,

            // 发布商情
            formTrade: {
                content: ''
            },
            hasBusinessRoot: false,
            hasOfferRoot: false,
            addParams: [],
            selections: [],
            isSubmitLoading: false

        }
    },
    mounted () {
        this.type = getQueryString('type') ? decodeURI(getQueryString('type')) : '发布报价'
        this.getUserInfo();
        
    },
    methods: {
        /* 获取用户id */
    /* 获取用户和企业信息 start */
        getUserInfo () {
            const self = this;
            const token_cyw = self.$cookies.get('token_cyw');
            if (token_cyw) {
                self.getUserAllInfo(token_cyw);
            } else {
                
            }
        },
        /* 获取用户全部信息 */
        getUserAllInfo (token_cyw, type) {
            const self = this;

            self.$get(`${baseUrl.business}/api/user/userByToken/${token_cyw}`, {}).then(res_1 => {
                if (res_1.status == 200) {
                    self.userInfo = res_1.data;
                    self.findByPhone();
                } else {
                    self.$message.error(res_1.msg);
                    self.$cookies.remove('token_cyw');
                    self.$router.go(0);
                }
            }).catch(err_1 => {
                self.$message.error('请求错误');
            })
        },
        // 获取企业信息 /api/businessInfo/findByPhone
        findByPhone () {
            const self = this;
            self.$get(`${baseUrl.business}/api/enterprise/findByPhone/${self.userInfo.phone}`, {}).then(res => { //${self.userInfo.telephone}
                if (res.status == 200) {
                    self.enterpriseInfo = res.data;
                    if (res.data.businessStatus) {
                        self.hasBusinessRoot = true;
                    } else {
                        self.hasBusinessRoot = false;
                    } 
                    if (res.data.offerStatus) {
                        self.hasOfferRoot = true;
                        self.findByEnterpriseId();
                    } else {
                        self.hasOfferRoot = false;
                    }
                } else {
                    self.$message.error(res.msg);
                }
            })
        },
         /* 获取用户和企业信息 end */

        // 企业发布类型
        changeType () {
            const self = this;
            if (self.type == '发布报价') {
                // 根据手机号查询报价列表
            } else {
                // 获取企业能发布的品种
                // self.findByEnterprise()
                self.formTrade.content = '';
            }
        },


    /* 发布商情 start */
        onTradeSubmit () {
            const self = this;
            if (self.formTrade.content == '') {
                self.$message({
                    type: 'warning',
                    message: '请填写发布内容'
                })
            } else {
                self.isSubmitLoading = true;
                const obj = {
                    content: self.formTrade.content,
                    userId: self.enterpriseInfo.user.userId,
                    enterpriseId: self.enterpriseInfo.id
                }
                self.$post(`${baseUrl.business}/api/businessInfo/add`, obj).then(res => {
                    if (res.status == 200) {
                        self.$message('发布成功')
                    } else {
                        self.$message.error(res.msg);
                    }
                    self.isSubmitLoading = false;
                }).catch(err => {
                    self.isSubmitLoading = false;
                    // self.$message.error('发布失败');
                })
            }
        },
    /* 发布商情 end */

    /* 发布报价 start */

        // 根据企业id查询能发布的报价enterpriseInfo
        findByEnterpriseId () {
            const self = this;
            self.$get(`${baseUrl.business}/api/enterpriseVarieties/findByEnterpriseApp/${self.enterpriseInfo.id}`, {}).then(res => {
                if (res.status == 200) {
                    if (res.data.length > 0) {
                        self.quoteList = [];
                        const content = res.data;
                        let obj = {};
                        content.forEach((item, index) => {
                            obj = {};
                            item.data.forEach((cItem, cIndex) => {
                                obj = {
                                    id: cItem.offerDetail ? cItem.offerDetail.id : '',
                                    enterpriseVarietiesId: cItem.id,
                                    price: cItem.offerDetail.price ? cItem.offerDetail.price : '', // 价格
                                    offerDate: cItem.offerDetail.offerDate ? cItem.offerDetail.offerDate : '',
                                    varietiesName: item.rootVarieties.name + '-' + cItem.varieties.name, // 品种名称
                                    attribute: '', // 属性
                                    attribute2: [], // 属性
                                    market: cItem.market, // 市场
                                    factory: cItem.factory, // 产地/厂家
                                    warehouse: cItem.warehouse, // 仓库
                                    remark: cItem.offerDetail.remark ? cItem.offerDetail.remark : '', // 备注
                                    createTime: cItem.offerDetail.createTime ? cItem.offerDetail.createTime.substr(0, 10) : self.getTime(),
                                    attributeInfos: cItem.attributeInfos ? cItem.attributeInfos : [],
                                    isShowPriceInput: false,
                                    isShowRemarkInput: false
                                }
//                              if (cItem.varieties.attributeInfos && cItem.varieties.attributeInfos.length > 0) {
//                                  let arr = [];
//                                  cItem.varieties.attributeInfos.forEach((attr, i) => {
//                                      if (i < 1) {
//                                          attr.fieldInfos.forEach((cAttr, cI) => {
//                                              arr.push(cAttr.fieldValue)
//                                          })
//                                      } else { return; }
//                                  })
//                                  obj.attribute = arr.join(', ');
//                              }
                                if (cItem.attributeInfoFiledInfos && cItem.attributeInfoFiledInfos.length > 0) {
                                    let arr = [];
                                    cItem.attributeInfoFiledInfos.forEach((attr, i) => {
                                            arr.push(attr.attributeInfo.content+":"+attr.fieldInfo.fieldValue);
                                           obj.attribute2.push({"content":attr.attributeInfo.content,"fieldValue":attr.fieldInfo.fieldValue});
                                    })
                                    obj.attribute = arr.join(', ');
                                }
                                self.quoteList.push(obj);
                            })
                        })
                        self.totalnum = self.quoteList.length;
                        self.quoteNone = false;
                    } else {
                        self.quoteNone = true;
                    }
                }
            })
        },

        // 按价格排序
        sortByPrice (obj1, obj2) {
            // console.log(obj1, obj2)
        },
        // 分页
        handleCurrentChange (page) {
            this.pageNo = page;
            this.findByEnterpriseId();
        },

        // 显示价格输入框
        showPriceInput (item) {
            item.isShowPriceInput = true;
        },
        hidePriceInput (item, index) {
            const self = this;
            item.isShowPriceInput = false;
            let obj = {
                price: item.price,
                id: item.id,
                enterpriseVarietiesId: item.enterpriseVarietiesId,
                remark: item.remark,
                offerDate: item.offerDate,
                incr: ''
            }
            self.addParams[index] = obj;
            
        },
        // 显示描述输入框
        showRemarkInput (item) {
            item.isShowRemarkInput = true;
        },
        hideRemarkInput (item, index) {
            item.isShowRemarkInput = false;
            let obj = {
                price: item.price,
                id: item.id,
                enterpriseVarietiesId: item.enterpriseVarietiesId,
                remark: item.remark,
                offerDate: item.offerDate,
                incr: ''
            }
            this.addParams[index] = obj;
        },
        // 发布报价
        addQuote () {
            const self = this;
            self.addParams = self.addParams.filter((s) => {
                return s
            })
            let check_new_arr = [];
            let check_obj = {};
            self.addParams.forEach((item, index) => {
                check_obj = {
                    price: item.price,
                    enterpriseVarietiesId: item.enterpriseVarietiesId
                }
                check_new_arr.push(check_obj);
            })
            self.$post(`${baseUrl.business}/api/offer/batchCheckThreshold`, check_new_arr).then(res => {
                if (res.status == 200) {
                    self.updateBatchAjax(self.addParams, '');
                } else if (res.status == 400) {
                    self.$alert(res.msg, '', {
                        confirmButtonText: '确定',
                        callback: action => {
                            self.updateBatchAjax(self.addParams, '');
                        }
                    });
                } else {
                    self.$message.error(res.msg);
                }
            })
        },

        // 选择列表时 存储选中数据
        selectionChange (selection) {
            this.selections = selection;
        },

        // 批量改价
        showBatch () {
            const self = this;
            if (self.selections.length > 0) {
                self.batchPrice = 0;
                self.checksNum = self.selections.length;
                self.dialogWithBatch = true;
            } else {
                self.$message({
                    message: '请选择需要修改的数据',
                    type: 'warning'
                })
            }

        },
        onBatchSubmit () {
            const self = this;
            let new_arr = [];
            let obj = {};
            let check_new_arr = [];
            let check_obj = {};
            let hasLittleNum = false;
            self.selections.forEach((item, index) => {
            	 if (item.price && Number(self.batchPrice) > 0) {
//              if (item.price && (Number(item.price) + Number(self.batchPrice) > 0)) {
                    obj = {
                        price: item.price,
                        id: item.id,
                        enterpriseVarietiesId: item.enterpriseVarietiesId,
                        remark: item.remark,
                        offerDate: self.getTime(),
                    }
                    check_obj = {
                        price: Number(item.price) + Number(self.batchPrice),
                        enterpriseVarietiesId: item.enterpriseVarietiesId
                    }
                    check_new_arr.push(check_obj);
                    new_arr.push(obj);
                } else {
                    hasLittleNum = true;
                    self.$message({
                        message: '价格不能小于0，请确认后修改',
                        type: 'warning'
                    })
                    return;
                }
            })
            if (!hasLittleNum) {
                self.$post(`${baseUrl.business}/api/offer/batchCheckThreshold`, check_new_arr).then(res => {
                    if (res.status == 200) {
                        self.updateBatchAjax(new_arr, self.batchPrice);
                    } else if (res.status == 400) {
                        self.$alert(res.msg, '', {
                            confirmButtonText: '确定',
                            callback: action => {
                                self.updateBatchAjax(new_arr, self.batchPrice);
                            }
                        });
                    }else {
                        self.$message.error(res.msg);
                    }
                })
            }
            
        },

        // 批量更新价格
        updateBatchAjax (arr, val) {
            const self = this;
            self.isSubmitLoading = true;
            const obj = {};
            obj.offerDetailVos =  arr;
            val ? obj.incr = Number(val) : '';
            self.$put(`${baseUrl.business}/api/offer/updateBatch`, obj).then(res_1 => {
                if (res_1.status == 200) {
                    self.isSubmitLoading = false;
                    self.addParams = [];
                    self.$message('发布成功');
                    self.dialogWithBatch = false;
                    self.findByEnterpriseId();
                } else {
                    self.isSubmitLoading = false;
                    self.$message.error(res_1.msg)
                }
            }).catch(err => {
                self.isSubmitLoading = false;
                self.$message.error('发布失败')
            })
        },

        // 按品种改价
        showVarieties () {
            const self = this;
            let batchTypes = self.enterpriseInfo.varieties;
            self.batchPrice = 0;
            self.dialogWithVarieties = true;
            self.batchType = batchTypes;
            self.checkBatchType = [];
            self.batchTypeCheck = [];
        },
        onBatchSubmit2 () {
            const self = this;
            if (self.checkBatchType) {
                self.isSubmitLoading = true;
                let obj = {
                    incr: self.batchPrice,
                    enterpriseId: self.enterpriseInfo.id,
                    varietiesIds: self.checkBatchType
                };
                self.$post(`${baseUrl.business}/api/offer/batchCheckThresholdByids`, obj).then(res => {
                    if (res.status == 200) {
                        self.$put(`${baseUrl.business}/api/offer/updateByVarieties`, obj).then(res_1 => {
                            if (res_1.status == 200) {
                                self.checkBatchType = [];
                                self.$message('发布成功');
                                self.dialogWithVarieties = false;
                                self.findByEnterpriseId();
                            } else {
                                self.$message.error(res_1.msg);
                            }
                            self.isSubmitLoading = false;
                        }).catch((err) => { self.$message.error('发布失败'); self.isSubmitLoading = false; })
                    } else if (res.status == 400) {
                        self.$alert(res.msg, '', {
                            confirmButtonText: '确定',
                            callback: action => {
                                self.$put(`${baseUrl.business}/api/offer/updateByVarieties`, obj).then(res_1 => {1
                                    if (res_1.status == 200) {
                                        self.checkBatchType = [];
                                        self.$message('发布成功');
                                        self.dialogWithVarieties = false;
                                        self.findByEnterpriseId();
                                    } else {
                                        self.$message.error(res_1.msg);
                                    }
                                    self.isSubmitLoading = false;
                                }).catch((err) => { self.$message.error('发布失败'); self.isSubmitLoading = false; })
                            }
                        });
                    } else {
                        self.isSubmitLoading = false;
                        self.$message.error(res.msg);
                    }
                })
                
            }
        },
        changeBatchType (val) {
            this.checkBatchType.push(val.id);
        },
         

        
        /* 获取用户id */  
        handleEdit (index, row) {// const param = $.extend(true, {}, self.formEdit)
            this.formEdit = $.extend(true, {}, row);
            this.dialogWithEdit = true;
        },
        handleDetail(index, row) {
            this.formEdit = $.extend(true, {}, row);
            this.dialogWithDetail = true;
        },

        // 发布
        onVarietiesSubmit () {
            const self = this;
            self.isSubmitLoading = true;
            if (self.formEdit.price >= 0) {
                const obj = {
                    price: self.formEdit.price,
                    enterpriseVarietiesId: self.formEdit.enterpriseVarietiesId,
                    remark: self.formEdit.remark,
                    offerDate: self.getTime()
                }
                self.$post(`${baseUrl.business}/api/offer/add`, obj).then(res_1 => {
                    if (res_1.status == 200) {
                        self.$message('发布成功');
                        self.isSubmitLoading = false;
                        self.dialogWithEdit = false;
                        self.findByEnterpriseId();
                    } else {
                        self.isSubmitLoading = false;
                        self.$message.error(res_1.msg);
                    }
                })
            } else {
                self.isSubmitLoading = false;
                self.$message({
                    message: '价格不能小于0',
                    type: 'warning'
                })
            }
            
        },
    /* 发布报价 start */
        // 获取当前时间
        getTime () {
            const date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            month = month > 10 ? month : '0' + month;
            let day = date.getDate();
            day = day > 10 ? day : '0' + day;
            return `${year}-${month}-${day}`;
        },
    }
    
}
</script>

<style scoped>
    .quote-add-btns .el-button--danger,
    .quote-add-btns .el-button--danger:hover { border-color: #a30000; color: #a30000; background: #fff; }
    .trade-add-btns .el-button--danger,
    .trade-add-btns .el-button--danger:hover { border-color: #a30000; color: #fff; background: #a30000; }
    
    .table-title { line-height: 35px; }
    .form-trade { margin-top: 30px; margin-bottom: 0; padding-bottom: 20px; width: 700px; }
    .trade-tag { margin-right: 10px; }
</style>